module.exports = __webpack_public_path__ + "static/media/vf_wouter_core.7759e901.svg";